export const renderClientOnlyLoaderToken = '_CLIENT_ONLY_LOADER_';
